export enum BookingCalendarTypes {
  API_SUCCESS = '@@bookingCalendar/API_SUCCESS',
  API_FAIL = '@@bookingCalendar/API_FAIL',
  GET_EVENTS = '@@bookingCalendar/GET_EVENTS',
  ADD_NEW_EVENT = '@@bookingCalendar/ADD_NEW_EVENT',
  UPDATE_EVENT = '@@bookingCalendar/UPDATE_EVENT',
  UPDATE_EVENT_SUCCESS = '@@bookingCalendar/UPDATE_EVENT_SUCCESS',
  UPDATE_EVENT_FAIL = '@@bookingCalendar/UPDATE_EVENT_FAIL',
  DELETE_EVENT = '@@bookingCalendar/DELETE_EVENT',
  DELETE_EVENT_SUCCESS = '@@bookingCalendar/DELETE_EVENT_SUCCESS',
  DELETE_EVENT_FAIL = '@@bookingCalendar/DELETE_EVENT_FAIL',
  GET_CATEGORIES = '@@bookingCalendar/GET_CATEGORIES',
  GET_CATEGORIES_SUCCESS = '@@bookingCalendar/GET_CATEGORIES_SUCCESS',
  GET_CATEGORIES_FAIL = '@@bookingCalendar/GET_CATEGORIES_FAIL',
  RESET_CALENDAR = '@@bookingCalendar/RESET_CALENDAR',
}

export interface BookingCalendarState {
  events: Array<any>;
  categories: Array<any>;
  error: object;
  isEventUpdated?: boolean;
}
